"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var react_select_1 = require("react-select");
var styled_1 = __importDefault(require("../../../styled"));
var tokens_1 = require("../../../tokens");
exports.MenuList = function (props) { return (React.createElement(exports.MenuList.Element, null,
    React.createElement(react_select_1.components.MenuList, __assign({}, props, { className: "cosmos-menu-list" })))); };
exports.MenuList.Element = styled_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border-radius: ", ";\n  overflow: hidden;\n\n  > .cosmos-menu-list {\n    padding-top: ", ";\n    padding-bottom: ", ";\n\n    & > *:nth-last-child() {\n      margin-bottom: ", ";\n    }\n  }\n"], ["\n  border-radius: ", ";\n  overflow: hidden;\n\n  > .cosmos-menu-list {\n    padding-top: ", ";\n    padding-bottom: ", ";\n\n    & > *:nth-last-child() {\n      margin-bottom: ", ";\n    }\n  }\n"])), tokens_1.misc.radius, tokens_1.spacing.xsmall, tokens_1.spacing.xsmall, tokens_1.spacing.xsmall);
exports.MenuList.theme = function (provided) { return (__assign({}, provided, { paddingTop: 0, paddingBottom: 0 })); };
var templateObject_1;
//# sourceMappingURL=menu-list.js.map